import src from "IMAGE";
export default { src, width: 472, height: 480, blurWidth: 0, blurHeight: 0};
